<div class="layout-container">

  <header class="game-header">
    <a class="icon-button" routerLink="/">
      <img src="assets/arrow_back.svg" alt="Back" />
    </a>

    <h1 class="game-title">The <span>Impostor</span><sup> BETA</sup></h1>
    <p class="game-subtitle">Enter a room, type your name and play!</p>
  </header>

  <main class="main-content">

    <app-room-setup
      (connectionCallback)="initializeListeners()"
      (roomIdListener)="setRoomId($event)"
    />

    @if (room_id()) {

      @if (is_waiting_for_game_end()) {

        <div class="waiting-state">
          <div class="loader"></div>
          <p class="waiting-text">There is an active game in this room, please wait for it to finish</p>
        </div>

      }
      @else {

        <div class="players-list">
          @for (player of player_names(); track player) {
            <div class="player-badge">{{ player }}</div>
          }
        </div>

        @if (!is_name_submitted()) {

          <div class="input-group">
            <input class="name-input" [class.invalid]="local_player_name().length > 0 && !is_name_valid()" type="text" placeholder="Your name" [value]="name_input()" (input)="updateNameInput($event)" />

            <div class="error-container">
              @if (local_player_name().length > 0 && !is_name_valid()) {
                <p class="error-message">Name already taken</p>
              }
            </div>

            <button class="action-button primary" [disabled]="!is_name_valid()" (click)="submitName()">Submit</button>
          </div>

        }
        @else {

          <div class="action-area">
            @if (!is_game_start_requested()) {
              <button class="action-button primary large" (click)="startGame()">Start Game</button>
            }
            @else {
              <div class="waiting-state inline">
                <div class="loader"></div>
                <p class="waiting-text">Waiting for every player to start the game</p>
              </div>
            }
          </div>

        }

        <p class="status-message muted">The game starts once everyone hits Start Game. A minimum of 3 players is required.</p>

      }

    }

  </main>

  <footer class="game-footer">
    <p class="copyright">© 2026 Ludico. All rights reserved.</p>
    <!--<p class="info-links">
      <a routerLink="/mind-link/about" [queryParams]="{ room: room_id() }">About</a>
    </p>-->
  </footer>

</div>